import { React, ts } from '_core';

import Chart from './chart';

type TreeModelsAlphaGoodnessOfFitProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  context?: ts.types.signal.SignalAnalysisContext;
  widgetPaths: Record<'tree_models_goodness_of_fit', string>;
  title: string;
};

const TreeModelsAlphaGoodnessOfFit = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: TreeModelsAlphaGoodnessOfFitProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['tree_models_goodness_of_fit']}
      fullScreen={fullScreen}
      title={title}
    />
  );
};

export default TreeModelsAlphaGoodnessOfFit;
